interface DividerPreviewProps {
  props: Record<string, string | number | boolean>
}

export function DividerPreview({ props }: DividerPreviewProps) {
  const color = props.color as string
  const thickness = (props.thickness as string) || '1'

  return (
    <div className="py-2">
      <hr
        className="border-tf-border"
        style={color
          ? { border: 'none', borderTop: `${thickness}px solid ${color}` }
          : { borderWidth: 0, borderTopWidth: `${thickness}px`, borderTopStyle: 'solid' }
        }
      />
    </div>
  )
}
